module.exports = __webpack_public_path__ + "assets/Openbite selected.7ab485d0b1a4055d3b5c364bb111669b.png";